import { ProcessoMovimento } from '../../processo-movimento/processo-movimento.model';
import { ProcessoDocumento } from '../../processo-documento/processo-documento.model';
import { ProcessoClasse } from '../../processo-classe/processo-classe.model';
import {ProcessoDistribuicao} from '../../processo-distribuicao/processo-distribuicao.model';

export abstract class LinhaDoTempo<E> {

  constructor(public item: E) {}

  public abstract getTipo(): string;
  public abstract getData(): Date;
  public abstract getIcone(): string;
  public abstract getDescricao(): string;

  public abstract getItem(): E;

}

export class ProcessoClasseLinhaTempo extends LinhaDoTempo<ProcessoClasse> {
  public getTipo(): string {
    return 'Classe';
  }

  public getIcone(): string {
    return 'pi pi-sitemap';
  }

  public getDescricao(): string {
    return this.item.classe.descricao;
  }

  public getData(): Date {
    return this.item.dataInicio;
  }

  public getItem(): ProcessoClasse {
    return this.item;
  }
}

export class ProcessoDistribuicaoLinhaTempo extends LinhaDoTempo<ProcessoDistribuicao> {
  public getTipo(): string {
    return 'Distribuição';
  }

  public getIcone(): string {
    return 'pi pi-share-alt';
  }

  public getDescricao(): string {
    return this.item.orgaoJulgador.nome;
  }

  public getData(): Date {
    return this.item.dataInicio;
  }
  public getItem(): ProcessoDistribuicao {
    return this.item;
  }
}

export class ProcessoDocumentoLinhaTempo extends LinhaDoTempo<ProcessoDocumento> {
  public getTipo(): string {
    return 'Documento';
  }

  public getIcone(): string {
    return 'pi pi-id-card';
  }

  public getDescricao(): string {
    return this.item.nome;
  }

  public getData(): Date {
    return this.item.dataJuntada;
  }

  public getItem(): ProcessoDocumento {
    return this.item;
  }
}

export class ProcessoMovimentoLinhaTempo extends LinhaDoTempo<ProcessoMovimento> {
  public getTipo(): string {
    return 'Movimento';
  }

  public getIcone(): string {
    return 'pi pi-chart-line';
  }

  public getDescricao(): string {
    return this.item.descricao;
  }

  public getData(): Date {
    return this.item.data;
  }
  public getItem(): ProcessoMovimento {
    return this.item;
  }
}

export class LinhaTempoData {
  itens: LinhaTempoMomento[];
}

export class LinhaTempoMomento {
  itens: LinhaDoTempo<any>[];
}
